(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Card Info Link Func: ", $scope, element, attrs);
  }

  var controllerFunction = function($scope, UserSession, $stateParams, $rootScope, CAD, webAnalytics) {

    $scope.card = $scope.accountDetails;
    $scope.editMode = $scope.card && $scope.card.paymentMethodId ? true : false;
    $scope.showMaskingButtons = true;

    $scope.maskClick = function(ev) {
        if($scope.enableKeydownMask) {
          //select
            ev.currentTarget.select();
        } else {
              $scope.showCardNumber();
        }
    }
 
    $scope.checkCardExpiration = function(year,month) {
      return moment("01-"+ month + "-" + year, "DD-MM-YYYY").isBefore(moment(),'year','month');
    }
    $scope.maskKeydown = function(ev) {
      if($scope.enableKeydownMask) {
        if(ev.keyCode >= 48 && ev.keyCode <= 57) {
          $scope.accountNumber = String.fromCharCode(ev.keyCode);
          $("#ccShowBlock input").val($scope.accountNumber);
          $scope.invalidCardIndicator = true;
        } else {
          $("#ccShowBlock input").val('');
          //$scope.$parent.cardInfoForm.cardAccountNum.$viewValue = '';
          $scope.accountNumber = '';
          $("#ccShowBlock input").val('');
          $scope.invalidCardIndicator = true;
          }
          $rootScope.$broadcast('setCardAccountNumOnAdd', {cardAccountNum: $scope.accountNumber});
          $scope.showMask = false;

          setTimeout(function(){
            
            $("#ccShowBlock input").focus();
          }, 100);
          
        
      }
    }

    $scope.isFEPClient = false;

    $scope.contactUs = function () {
      /**
       * Create Tags for Add/Edit a card
       * Added WTS link_name, link_trackvars, link_trackevents
       */
      var utagObj = {};
      utagObj.link_trackvars = "events";
      utagObj.link_trackevents = "event00";
      var isAddCard = false;
      if($scope.card.transactionMode === 'ADD' && !$stateParams.editMode){
        isAddCard = true;
      }
      var getBrandingInfoObj = CAD.getBrandingInfos();
      if (getBrandingInfoObj != "" && getBrandingInfoObj && getBrandingInfoObj[0].clientInfo.clientName == 'FEP') {
          if(isAddCard){
            utagObj.link_name = "Custom: add credit card: contact us fep";
          }else{
            utagObj.link_name = "Custom: edit credit card: contact us fep";
          }
          $scope.isFEPClient = true;
      }else{
        if(isAddCard){
          utagObj.link_name = "Custom: add credit card: contact us";
        }else{
          utagObj.link_name = "Custom: edit credit card: contact us";
        }
      }
      webAnalytics.webTrendsUtag("LINK", utagObj, undefined);
      cvsUtility.checkIfFepClient($scope.isFEPClient);
    };

    // $scope.validateCardNumber  = function(card_info) {
    //   if(!$scope.editMode) {
    //     $scope.$parent.validateCardNumber(card_info);
    //   }
    // }
   
    if($scope.card.transactionMode === 'ADD' && $stateParams.editMode){
      $scope.showMaskingButtons = false;
      $scope.invalidCardIndicator = false;
      $scope.showMask = true;
      setTimeout(function () {
        $scope.hideCardNumber();
      }, 300);

      $scope.enableKeydownMask = true;

    }





    $scope.wcmContent = wcmContent;
    // $scope.isMobile = cvsUtility.isMobile();
    function getYears(offset, range){
      var currentYear = new Date().getFullYear();
      var years = [];
      for (var i = 0; i < range + 1; i++){
        var yearat=currentYear + offset + i;
        years.push(""+yearat);
      }
      return years;
    }
    $scope.years = getYears(0,10);
    if($scope.editMode){
      $scope.showMaskingButtons = false;
      $scope.accountNumber = $scope.card.accountNumber;
      $scope.firstName = $scope.card.cardholder.firstName;
      $scope.lastName = $scope.card.cardholder.lastName;
      $scope.month = $scope.card.expiryDate && $scope.card.expiryDate.month;
      $scope.year = $scope.card.expiryDate && $scope.card.expiryDate.year;
    }else{

      $scope.year = $scope.years[0];

    }


    /*if($scope.$parent.editFromAutoPayments && localStorage.getItem("transactionMode") === 'ADD'){
      $scope.editMode = false;
    }*/
    if($scope.editFromAutoPayments){
      if($scope.editFromAutoPayments && localStorage.getItem("transactionMode") === 'ADD' || localStorage.getItem("transactionMode") === ''){
        $scope.editMode = false;
      } else {
        $scope.editMode = true;
      }
    }

    if(!$scope.editMode){
      $scope.accountNumber = null;
    }
    // $scope.focusAccountNumberInEdit = function (ev) {
    //   console.log("keydown", ev);
    //   if (ev.keyCode >= 48 && ev.keyCode <= 57) {
    //     $scope.accountNumber = ev.keyCode - 48;
    //   } else {
    //     $scope.accountNumber = null;
    //   }
    //   $scope.mask_accountNumber = "";
    //   // $scope.ccMode = 'number';
    //   setTimeout(function () {
    //     var txtBox = document.getElementById("card-accountNumber");
    //     txtBox.focus();
    //     //txtBox.select();
    //   }, 200);
    // }

    /*$scope.validateCardNumber = function(cardNumber){
      if(cardNumber && cardNumber.length>=14){
        $scope.$parent.validateCardNumber(cardNumber);
      }
    };*/
  };

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/cardInfo/cardInfo.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "userSession", '$stateParams', '$rootScope', "cvsAppData", "webAnalytics"];
  angular.module('cvsApp').directive('cardInfo', directiveFunction);

})();
